import { nextItem, nextItemOutlined } from "./navigationMarkup";
export var getNextItemMarkup = function getNextItemMarkup(isShowingPageNumbers) {
  return isShowingPageNumbers ? nextItemOutlined : nextItem;
};